var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"emptyWrapper"},[_c('div',{staticClass:"emptyIconWrapper"},[_c('empty-box-icon',{attrs:{"width":"100","height":"100"}})],1),_c('div',{staticClass:"emptyTitle"},[_vm._v("Хоосон байна")])])}
var staticRenderFns = []

export { render, staticRenderFns }